import React from 'react'
import styled, { withTheme } from 'styled-components'
import { TFButton } from '../TF'

const DefaultButton = styled.button`
  background: var(--clr-btn);
  border: 1px solid var(--clr-btn);
  padding: 7px 20px;
  color: var(--clr-black-to-main);
  &:hover {
    text-decoration: none;
  }
  &:focus {
    outline:none;
  }
  &:active {
    box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
  }

  display: block;
  text-align: center;
  margin: 30px auto 0;
  width: 300px;
  border-radius: var(--button-border-radius);
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(19,51,61,0.5);
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
`
const Button = ({ theme, children }) => (
  <Choose>
    <When condition={!theme.getOption('tfcustomer')}>
      <DefaultButton>{children}</DefaultButton>
    </When>
    <Otherwise>
      <TFButton>{children}</TFButton>
    </Otherwise>
  </Choose>
)

export default withTheme(Button)



// WEBPACK FOOTER //
// ./src/components/Button/index.js